// Shared license expiration status → badge mapping. Spec §5.3:
//   green = current · yellow = expiring (T-60/T-30) · red = expired.
// Badge variants: success (green), warning (amber), accent (coral≈red),
// outline (neutral, for perpetual / no-expiry licenses).

const EXPIRING_WINDOW_DAYS = 60;

// daysUntil and fmtDate are THE canon (./date-display.js), re-exported by
// IDENTITY. Both were already correct here (they split the string rather than
// calling new Date on it), which is why this file never showed a wrong day.
// They are collapsed anyway: two correct copies of one rule are still two
// copies, and the next edit only lands on one of them.
export { daysUntil } from './date-display.js';
import { daysUntil as daysUntilCanon, formatDateOrDash } from './date-display.js';

export function licenseStatus(expirationDate) {
  if (!expirationDate) return { key: 'perpetual', label: 'No expiry', variant: 'outline', days: null };
  const days = daysUntilCanon(expirationDate);
  if (days < 0) return { key: 'expired', label: 'Expired', variant: 'accent', days };
  if (days <= EXPIRING_WINDOW_DAYS) return { key: 'expiring', label: `Expires in ${days}d`, variant: 'warning', days };
  return { key: 'current', label: 'Current', variant: 'success', days };
}

export const fmtDate = formatDateOrDash;
